import React from 'react';
import { motion } from 'framer-motion';
import { BRAND } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { SmartImage } from './SmartImage';
import { SparkIcon } from './icons/LineIcons';
const pillars = [{
  title: 'Presencia en medios',
  text: 'Conducción con oficio, ritmo y criterio editorial delante de cámara.'
}, {
  title: 'Conexión humana',
  text: 'Historias contadas con cercanía, para que la audiencia recuerde la marca.'
}, {
  title: 'Estándar audiovisual',
  text: 'Cada pieza se produce con acabado profesional, de la idea al montaje final.'
}];
export function About() {
  return <section id="sobre" className="relative w-full overflow-hidden bg-ink py-20 sm:py-24 lg:py-32" aria-labelledby="sobre-title" data-id="element-13" data-mp="3djfa7opquapv">
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 bottom-0 hidden h-72 w-72 rounded-full bg-gold/[0.06] blur-3xl lg:block" data-id="element-14" data-mp="3miskgjloz3bn" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16 lg:px-10" data-id="element-15" data-mp="2lrqocouhz40m">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="relative order-2 lg:order-1" data-id="element-16" data-mp="2gr2yw7lx2v8i">
          <div aria-hidden="true" className="absolute -inset-4 rounded-[16px] bg-gold/[0.07] blur-3xl" data-id="element-17" data-mp="34hgta4rz5669" />
          <div className="relative overflow-hidden rounded-card border border-white/[0.08] bg-graphite" data-id="element-18" data-mp="30heovnuutyna">
            <SmartImage src={BRAND.logoUrl} alt="Logotipo NORBERTH Presenta" width={1536} height={1024} wrapperClassName="aspect-[3/2] w-full" className="absolute inset-0 h-full w-full object-cover" data-id="element-19" data-mp="2vnu2kt2mit3x" />
          </div>
          <div aria-hidden="true" className="mt-4 h-px w-2/3 bg-gradient-to-r from-gold/60 to-transparent" data-id="element-20" data-mp="3jdod33zh05l0" />
        </motion.div>

        <div className="order-1 lg:order-2" data-id="element-21" data-mp="b3vhf4gh0hsz">
          <SectionHeading eyebrow="Sobre Norberth" title={<span id="sobre-title" data-id="element-23" data-mp="3tio0ck4z4sol">
                Una marca <span className="text-gold" data-id="element-24" data-mp="1elnrk5zar2r">audiovisual</span> con
                nombre propio
              </span>} description="NORBERTH Presenta reúne conducción, producción y narrativa de marca en una sola identidad reconocible." data-id="element-22" data-mp="b71asvw4u5ui" />

          <ul className="mt-10 space-y-6" data-id="element-25" data-mp="3ohgs6jyx5rhe">
            {pillars.map((pillar, index) => <motion.li key={pillar.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.5
          }} transition={{
            duration: 0.45,
            delay: index * 0.08
          }} className="flex gap-4 border-l border-steel/70 pl-5 transition-colors duration-300 hover:border-gold/60" data-id="element-26" data-mp="3am4tk1hn7gv7" data-mpi={index}>
                <SparkIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-27" data-mp="2tazn90isdy3i" />
                <div data-id="element-28" data-mp="2t8myo4iiwphh">
                  <h3 className="font-display text-lg uppercase tracking-wide text-white" data-id="element-29" data-mp="371uobqn1nawj">
                    {pillar.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ash" data-id="element-30" data-mp="329uu8etnnc7v">
                    {pillar.text}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}